import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { isNull } from 'util';

import { DefaultLearnCertConfigDTO } from '../../model/learn-cert/default-learn-cert-config/default-learn-cert-config-dto';
import { LearnCertClass } from '../../model/learn-cert/learn-cert-class';
import { LearnCertClassDTO } from '../../model/learn-cert/learn-cert-class-dto';
import { LearnCertDisableConfig } from '../../model/learn-cert/learn-cert-disable-config/learn-cert-disable-config';
import { LearnCertEntry } from '../../model/learn-cert/learn-cert-entry';
import { LearnCertType } from '../../model/learn-cert/learn-cert-type';
import { DictDataParam } from '../../service/dict-data/dict-data-param';
import { DictDataParamType } from '../../service/dict-data/dict-data-param-type.enum';
import { DictDataType } from '../../service/dict-data/dict-data-type.enum';
import { NecDictDataService } from '../../service/dict-data/dict-data.service';
import { UserService } from '../../service/user/user.service';
import { JsonUtil } from '../../service/util/json.util';
import { DropDownMenuItem } from '../dropdown-menu/dropdown-menu-item';
import { LearnCertChosenResult } from './learncert-chosen-result';
import { LearnCertMenuItem } from './learncert-menu-item';

@Injectable()
export class NecLearnCertService {
  private key = 'learnCertClass';

  constructor(private dictDataService: NecDictDataService,
    private userService: UserService) {
  }

  /**
   * ç»è£å­¦ä¹ å­æ®éæ©ç»æ
   */
  packageLearnCertChosenResult(hasLearnCert: boolean, chosenLearncertMenuItem: Array<LearnCertMenuItem>,
    chosenChildTypeMenuItem: Array<DropDownMenuItem>, chosenLearncertvalue: Array<string>) {
    let learnCertChosenResult = new LearnCertChosenResult(hasLearnCert);
    learnCertChosenResult.entries = [];
    for (let i = 0; i < chosenLearncertMenuItem.length; i++) {
      learnCertChosenResult.entries.push(this.packageLearnCertItem(i, chosenLearncertMenuItem[i],
        chosenChildTypeMenuItem[i], chosenLearncertvalue[i]));
    }
    return learnCertChosenResult;
  }

  /**
   * ç»è£å­¦ä¹ ç»ä»¶èå
   */
  packageLearnCertMenu(result: Array<LearnCertClass>): Array<LearnCertMenuItem> {
    let menu: Array<LearnCertMenuItem> = [];
    result.forEach(item => {
      menu.push(new LearnCertMenuItem(item.id,
        item.name,
        item.enabled && !item.disabled,
        this.packageLearnCertMenuChildren(item.learnCertTypes)));
    });
    return menu;
  }

  /**
   * è·åå­¦ä¹ å­æ®å­å¸
   */
  getLearnCertDict(): Observable<LearnCertClass[]> {
    return this.dictDataService.getDictData(DictDataType.LEARN_CERT_CLASS).pipe(map((resp: LearnCertClassDTO[]) => {
      return JsonUtil.jsonConvert(this.packageLearnCertDict(resp), LearnCertClass);
    }));
  }

  /**
   * è·åå­¦ä¹ å­æ®ç¦ç¨éç½®å­å¸
   */
  getLearnCertDisableConfigDict(): Observable<LearnCertDisableConfig> {
    let param: DictDataParam = new DictDataParam(this.userService.getUserInfo().position.deptId, DictDataParamType.DEPT);
    return this.dictDataService.getDictData(DictDataType.LEARN_CERT_DISABLE_CONFIG, param).pipe(map((resp: LearnCertDisableConfig) => {
      return JsonUtil.jsonConvert(resp, LearnCertDisableConfig);
    }));
  }

  /**
   * è·åå­¦ä¹ å­æ®é»è®¤å¼æ¹æ¡
   */
  getDefaultLearnCertConfigByDeptId(deptId: number): Observable<DefaultLearnCertConfigDTO> {
    return this.dictDataService.getDictData(DictDataType.LEARN_CERT_DEFAULT_CONFIG, new DictDataParam(deptId, DictDataParamType.DEPT))
      .pipe(map((resp: DefaultLearnCertConfigDTO) => {
        return JsonUtil.jsonConvert(resp, DefaultLearnCertConfigDTO);
      }));
  }

  /**
   * è·åå­¦ä¹ å­æ®é»è®¤å¼æ¹æ¡
   */
  getDefaultLearnCertConfigByGroupId(groupId: number): Observable<DefaultLearnCertConfigDTO> {
    return this.dictDataService.getDictData(DictDataType.LEARN_CERT_DEFAULT_CONFIG, new DictDataParam(groupId, DictDataParamType.GROUP))
      .pipe(map((resp: DefaultLearnCertConfigDTO) => {
        return JsonUtil.jsonConvert(resp, DefaultLearnCertConfigDTO);
      }));
  }

  /**
   * ç»è£å­¦ä¹ å­æ®å­å¸
   */
  private packageLearnCertDict(learnCertObjs: LearnCertClassDTO[]): LearnCertClass[] {
    let learnCertDicts: LearnCertClass[] = [];
    learnCertObjs.forEach((item: LearnCertClassDTO) => {
      let learnCertDict: LearnCertClass = item.learnCertClass;
      learnCertDict.learnCertTypes = [];
      item.learnCertTypes.forEach(typeItem => {
        learnCertDict.learnCertTypes.push(JsonUtil.jsonConvert(typeItem, LearnCertType));
      });
      learnCertDicts.push(learnCertDict);
    });
    return learnCertDicts;
  }

  /**
   * ç»è£åæ¡å­¦ä¹ å­æ®
   */
  private packageLearnCertItem(idx: number, chosenLearncertMenuItem: LearnCertMenuItem,
    chosenChildTypeMenuItem: DropDownMenuItem, chosenLearncertvalue: string) {
    let learnCertItem = new LearnCertEntry();
    learnCertItem.idx = idx;
    learnCertItem.classId = !isNull(chosenLearncertMenuItem) ? chosenLearncertMenuItem.id : undefined;
    learnCertItem.typeId = !isNull(chosenChildTypeMenuItem) ? chosenChildTypeMenuItem.id : undefined;
    if (!isNull(chosenLearncertvalue)) {
      learnCertItem.number = Number(chosenLearncertvalue);
    }
    return learnCertItem;
  }

  /**
   * ç»è£å­èå
   */
  private packageLearnCertMenuChildren(children: Array<LearnCertType>) {
    let childrenItems: Array<DropDownMenuItem> = [];
    children.forEach(item =>
      // è¢«ç¦ç¨çå­¦ä¹ å­æ®ä¸å¨ä¸æåè¡¨ä¸­æ¾ç¤º
      childrenItems.push(new DropDownMenuItem(item.id, item.name, false, false, item.enabled && !item.disabled))
    );
    return childrenItems;
  }

  /**
   * å­¦åï¼æ¶ï¼æ°å¼æ£éª
   */
  checkLearnCertValue(value: number) {
    if (value === 0 || isNaN(value)) {
      return '';
    } else {
      let newValue = Math.floor(value * 100);
      return newValue > 100000 ? '' : newValue / 100 + '';
    }
  }

  resetDisabled(learnCertClasses: LearnCertClass[], disableConfig: LearnCertDisableConfig) {
    learnCertClasses = learnCertClasses || [];
    disableConfig = disableConfig || new LearnCertDisableConfig();

    learnCertClasses.forEach(learnCertClass => {
      learnCertClass.disabled = disableConfig.learnCertClassIds.some(classId => classId === learnCertClass.id);
      learnCertClass.learnCertTypes.forEach(learnCertType => {
        learnCertType.disabled = disableConfig.learnCertTypeIds.some(typeId => typeId === learnCertType.id);
      });
    });
  }
}
